import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { serverAnalytics } from '../services/serverAnalytics';

// Component to track route changes for server-side analytics
const RouteTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view when route changes
    serverAnalytics.trackPageView(location.pathname);
  }, [location.pathname]);

  return null; // This component doesn't render anything
};

export default RouteTracker;

